export default "__VITE_ASSET__023435ff__"